<template>
  <div>
    <BaseModal
      dataClass="manual_planning_edit-sort-modal"
      size="sm"
      :title="sortConditionCtrlInfo.title.label"
      v-bind="$attrs"
      v-on="$listeners"
      @show-modal="onShow"
    >
      <template v-slot:main>
        <div
          v-if="buttonItems"
          class="ml-1 mr-1 mb-3 row justify-content-between"
        >
          <div class="mb-2" v-for="(group, index) in buttonItems" :key="index">
            <BaseButton
              v-for="(item, index) in group"
              :key="index"
              class="mr-2"
              :variant="item.variant"
              :icon="item.icon"
              :columnInfo="item.columnInfo"
              :disabled="item.disabled"
              @click="item.onClickCallback"
            />
          </div>
          <!-- テーブル -->
          <b-table
            data-class="base-table"
            ref="sort_table"
            class="table table-bordered base-table"
            bordered
            hover
            no-border-collapse
            responsive
            :selectable="true"
            small
            sticky-header
            outlined
            select-mode="single"
            @row-selected="onRowSelected"
            :fields="fields"
            :items="tableItems"
            v-bind="$attrs"
            v-on="$listeners"
          >
            <template v-slot:cell(key1)="data">
              {{ data.index + 1 }}
            </template>
            <template v-slot:cell(order)="row">
              <b-form-select
                v-model="row.item.order"
                size="sm"
                :options="getListOptions(MASTER_CODE.SORT_ORDER, false),"
                v-bind="$attrs"
                v-on="$listeners"
              />
            </template>
          </b-table>
        </div>
      </template>
      <template v-slot:footer="{ cancel }">
        <!-- 設定ボタン -->
        <BaseButton
          variant="primary"
          :columnInfo="sortConditionCtrlInfo.ok"
          @click="select"
        />
        <!-- 閉じるボタン -->
        <BaseButton
          variant="primary"
          icon="times-circle"
          :columnInfo="sortConditionCtrlInfo.close"
          @click="cancel"
        />
      </template>
    </BaseModal>
  </div>
</template>
<script>
import { getListOptions } from '@/common/Common.js'
import _ from 'lodash'
export default {
  data() {
    return {
      selectedItems: [],
      sortConditionCtrlInfo: this.$store.getters['init/getScreens'](
        this.SCREEN_ID.MANUAL_PLANNING_EDIT
      )('sort_condition_ctrl_info'),
      currentSortConditions: [],
      movedIndex: -1,
    }
  },

  props: {
    selectedSortConditions: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    tableItems() {
      if (this.currentSortConditions.length > 0) {
        if (this.movedIndex >= 0) {
          this.$refs.sort_table.selectRow(this.movedIndex)
        }
        return this.currentSortConditions
      } else {
        return []
      }
    },

    fields() {
      let fields = this.$store.getters['init/getFields'](
        this.SCREEN_ID.MANUAL_PLANNING_EDIT
      )('sort_condition_header')

      fields.map((item) => {
        item.sortable = false
      })

      return fields
    },

    buttonItems() {
      return [
        // ボタングループ#1
        [],
        [
          // 上ボタン
          {
            variant: 'primary',
            icon: 'arrow-up',
            disabled: !this.canMoveUp,
            columnInfo: this.sortConditionCtrlInfo.up,
            onClickCallback: () => {
              this.moveUp()
            },
          },
          // 下ボタン
          {
            variant: 'primary',
            icon: 'arrow-down',
            disabled: !this.canMoveDown,
            columnInfo: this.sortConditionCtrlInfo.down,
            onClickCallback: () => {
              this.moveDown()
            },
          },
        ],
      ]
    },
    canMoveUp() {
      if (!this.selectedItems || this.selectedItems.length === 0) {
        return false
      }
      let selectedIndex = this.findSelectedSortItemIndex()
      if (selectedIndex === 0) {
        return false
      }
      return true
    },
    canMoveDown() {
      if (!this.selectedItems || this.selectedItems.length === 0) {
        return false
      }
      let selectedIndex = this.findSelectedSortItemIndex()
      if (selectedIndex === this.currentSortConditions.length - 1) {
        return false
      }
      return true
    },
  },

  methods: {
    getListOptions,

    onShow() {
      this.currentSortConditions = _.cloneDeep(this.selectedSortConditions)
    },

    onRowSelected(selectedItems) {
      this.selectedItems = selectedItems
      this.movedIndex = -1
    },

    findSelectedSortItemIndex() {
      if (!this.selectedItems || this.selectedItems.length === 0) {
        return -1
      }
      return this.currentSortConditions.findIndex(
        (item) => item.sort_key == this.selectedItems[0].sort_key
      )
    },

    moveUp() {
      let selectedIndex = this.findSelectedSortItemIndex()
      if (selectedIndex > 0) {
        let moveItems = this.currentSortConditions.splice(selectedIndex, 1)
        this.currentSortConditions.splice(selectedIndex - 1, 0, moveItems[0])
        this.movedIndex = selectedIndex - 1
      }
    },

    moveDown() {
      let selectedIndex = this.findSelectedSortItemIndex()
      if (
        selectedIndex >= 0 &&
        selectedIndex < this.currentSortConditions.length - 1
      ) {
        let moveItems = this.currentSortConditions.splice(selectedIndex, 1)
        this.currentSortConditions.splice(selectedIndex + 1, 0, moveItems[0])
        this.movedIndex = selectedIndex + 1
      }
    },

    select() {
      this.$bvModal.hide('manual-planning-edit-sort')
      this.$emit('after-close-set', this.currentSortConditions)
    },
  },
}
</script>
<style lang="scss" scoped>
.base-table {
  font-size: 0.8rem;
  th,
  td {
    padding: 5px;
    vertical-align: middle;
  }

  th {
    background-color: $primary;
    color: #eee;
    padding: 0 1rem;
    text-align: center;
    width: 130px;
  }
}
</style>
